module.exports = __webpack_public_path__ + "static/img/all.3311ac5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solutions/union/all.jpg
// module id = 9lef
// module chunks = 18